import type { SortingState } from '@tanstack/react-table';
import type { OrderSource, OrderSourceApiStatus } from '@api/orderSources';

export type { OrderSource };
export type OrderSourceStatus = OrderSourceApiStatus;

export const ORDER_SOURCE_STATUS_VALUES = ['active', 'inactive'] as const;

export interface OrderSourceTab {
  key: OrderSourceStatus;
  label: string;
}

export interface TabsTranslations {
  active: string;
  inactive: string;
}

export interface OrderSourceTranslations {
  tabs?: TabsTranslations;
  header?: {
    total_unfiltered?: string;
  };
  search?: {
    placeholder?: string;
    aria_label?: string;
  };
}

export const DEFAULT_TAB_LABELS: Record<OrderSourceStatus, string> = {
  active: 'Active',
  inactive: 'Inactive',
};

export interface OrderSourcesTabsProps {
  currentStatus: OrderSourceStatus;
  onStatusChange: (status: OrderSourceStatus) => void;
  disabled?: boolean;
  translations?: TabsTranslations;
  layoutId?: string;
  className?: string;
}

export interface OrderSourcesTableProps {
  orderSources: OrderSource[];
  totalCount: number;
  currentPage: number;
  pageSize: number;
  currentStatus: OrderSourceStatus;
  isLoading?: boolean;
  isFetching?: boolean;
  onPageChange: (page: number) => void;
  onPerPageChange?: (perPage: number) => void;
  onRowClick?: (orderSource: OrderSource) => void;
  onStatusToggle: (id: number, active: boolean) => void;
  sorting?: SortingState;
  onSortingChange?: (sorting: SortingState) => void;
  className?: string;
  // RBAC: when false, the row Edit + Activate/Deactivate actions are omitted.
  canWrite?: boolean;
}

export interface AllOrderSourcesPageProps {
  currentStatus: OrderSourceStatus;
  totalCount: number;
  onStatusChange: (status: OrderSourceStatus) => void;
  translations?: OrderSourceTranslations;
  isLoading: boolean;
  isFetching: boolean;
  orderSources: OrderSource[];
  currentPage: number;
  pageSize: number;
  onPageChange: (page: number) => void;
  onPerPageChange: (perPage: number) => void;
  onRowClick?: (orderSource: OrderSource) => void;
  onCreateNew?: () => void;
  onStatusToggle: (id: number, active: boolean) => void;
  sorting?: SortingState;
  onSortingChange?: (sorting: SortingState) => void;
  // RBAC: when false, the toolbar (New) and row actions are hidden.
  canWrite?: boolean;
}
